
class CapSelectDistrict {
  constructor(config) {
    this.canSelectDistrict = config['select_district']
    if (config['user_district_code']) {
      this.userDistrictCode = config['user_district_code']
    }
    else {
      this.userDistrictCode = undefined
    }
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return this.canSelectDistrict
  }

  getUserDistrictCode() {
    return this.userDistrictCode
  }
}

function key() {
  return 'select_district'
}

function create(config) {
  return new CapSelectDistrict(config)
}

export default {
  key,
  create,
}
